import styled from 'styled-components';

export const OrderSectionContainer = styled.div(({ theme }) => ({
  display: 'grid',
  flexDirection: 'column',
  paddingTop: theme.spacing[16],
  rowGap: theme.spacing[12],

  '> *': {
    paddingBottom: theme.spacing[8],
  },

  '> :not(:last-child)': {
    borderBottom: `1px solid ${theme.colors.surface05}`,
  },
}));

export const OrderLineItemsContainer = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  rowGap: theme.spacing[16],
  columnGap: theme.spacing[8],
  justifyContent: 'space-between',
}));

export const OrderAmountContainer = styled.div(({ theme }) => ({
  paddingBottom: theme.spacing[8],
}));
